import React from "react";
import Mathematics from "../../components/ClassThree/Mathematics";
import Science from "../../components/ClassThree/Science";
import SocialStudies from "../../components/ClassThree/SocialStudies";
import English from "../../components/ClassThree/English";

import MathematicsMenu from "./Mathematics";
import ScienceMenu from "./Science";
import SocialStudiesMenu from "./SocialStudies";
import EnglishMenu from "./English";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

// Define ClassTwoMenu with the proper type
const ClassThreeMenu: MenuItem[] = [
    { 
        url: "/class-three/mathematics", 
        title: "Mathematics", 
        component: Mathematics,
        subMenu: MathematicsMenu
    },
    { 
        url: "/class-three/english", 
        title: "English Language", 
        component: English,
        subMenu: EnglishMenu
    },
    { 
        url: "/class-three/science", 
        title: "Science", 
        component: Science,
        subMenu: ScienceMenu
    },
    // { 
    //     url: "/class-three/general-knowledge", 
    //     title: "General Knowledge", 
    // },
    { 
        url: "/class-three/social-studies", 
        title: "Social Studies & EVS", 
        component: SocialStudies,
        subMenu: SocialStudiesMenu
    },
    // { 
    //     url: "/class-three/computer", 
    //     title: "Computer", 
    // }
];

export default ClassThreeMenu;